import styled from 'styled-components';

const LinkMainDiv = styled.div`
  margin-bottom: ${props => (props.noMargin ? '' : '20px')};
  display: flex;
  align-items: baseline;

  button {
    flex: none;
  }
`;

LinkMainDiv.displayName = 'LinkMainDiv';

export default LinkMainDiv;
